import React from 'react';
import {
  Row, Col, Divider, Button} from 'antd';
import img from '../../../assets/img/freepik  Plant  inject 2@3x.png';
const NiprFeeRequest = (props) => {
  
  let {loas,niprfeerequest}=props;
  let {fee}=niprfeerequest[0];
  
  return (
    <div className="mi_model_popup">
    <Row span={24}>
        <Col span={18}>
          <p className='mi_title' style={{marginBottom:'25px'}}>Fee Estimate</p>
        </Col>
        <Col span={6}>
          <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={props.closeDrawerHandler} ></i>
        </Col>
      </Row>
      <Row span={24}>
        <Col  sm={12} >
          <p className="mi_name_pro">LOA</p>
          {loas&&loas.map(x=>{
            return           <p className="mi_value_pro">{x}</p>

          })}
        </Col>
        <Col sm={12} style={{textAlign:'right',paddingRight:'10px'}}>
          {/* <p className="mi_name_pro">Plan Id</p> */}
          <p className="mi_value_pro">State Fee: ${fee.stateFee}</p>
          <p className="mi_value_pro">NIPR Fee: ${fee.processingFee}</p>
          <Divider></Divider>
          <p className="mi_value_pro">Total State Fee: ${fee.stateFee}</p>
          <p className="mi_value_pro">Total NIPR Fee: ${fee.processingFee}</p>
          <p className="mi_value_pro">Grand Total: ${fee.totalFees}</p>


        </Col>
        <Col sm={24} style={{textAlign:'right',paddingRight:'10px',marginBottom:'20px'}}>
          <Button type="primary">Apply</Button>
        </Col>
      </Row>
      <Row>
      <img alt="example" style={{ height: '80px', marginBottom: '-28px', float: 'right' }} src={img} />
      </Row>
     </div>
  )
}
export default NiprFeeRequest;